import {TimeSpan} from '../interfaces/common.interfaces';
import {translateObject} from '@ngneat/transloco';
import {numberToAtLeastTwoCharsStr} from './string.functions';

export const distanceInMetersToPrettyString = (distance: number): string => {
  if (distance < 1000) {
    return `${distance.toFixed(0)}${translateObject('meterShort')}`;
  }
  return `${(distance / 1000).toFixed(1)}${translateObject('kilometerShort')}`;
};

export const timeToPrettyString = (time: TimeSpan): string => {
  if (time.days > 0) {
    // eslint-disable-next-line max-len
    return `${time.days}${translateObject('dt.d')} ${numberToAtLeastTwoCharsStr(time.hours)}${translateObject('dt.h')} ${numberToAtLeastTwoCharsStr(time.minutes)}${translateObject('dt.m')} ${numberToAtLeastTwoCharsStr(time.seconds)}${translateObject('dt.s')}`;
  }

  if (time.hours > 0) {
    // eslint-disable-next-line max-len
    return `${numberToAtLeastTwoCharsStr(time.hours)}${translateObject('dt.h')} ${numberToAtLeastTwoCharsStr(time.minutes)}${translateObject('dt.m')} ${numberToAtLeastTwoCharsStr(time.seconds)}${translateObject('dt.s')}`;
  }

  return `${numberToAtLeastTwoCharsStr(time.minutes)}${translateObject('dt.m')} ${numberToAtLeastTwoCharsStr(time.seconds)}${translateObject('dt.s')}`;
};

export const timeToTimerString = (time: TimeSpan): string => {
  if (time.days > 0) {
    // eslint-disable-next-line max-len
    return `${time.days}${translateObject('dt.d')} ${numberToAtLeastTwoCharsStr(time.hours)}:${numberToAtLeastTwoCharsStr(time.minutes)}:${numberToAtLeastTwoCharsStr(time.seconds)}`;
  }

  return `${numberToAtLeastTwoCharsStr(time.hours)}:${numberToAtLeastTwoCharsStr(time.minutes)}:${numberToAtLeastTwoCharsStr(time.seconds)}`;
}
